/* eslint-disable import/prefer-default-export */
import React from 'react';
import { IconProps } from './IconProps';
import { SVGWrapper } from './SVGWrapper';

export const MenuCollapse: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <path d="M2.6,21.7V2.3" />
        <polyline points="12.5,5.6 6.2,12 12.5,18.4" />
        <line x1="21.4" y1="12" x2="6.2" y2="12" />
    </SVGWrapper>
);
